import {
  CSSProperties,
  ChangeEventHandler,
  KeyboardEventHandler,
  RefObject,
  useContext,
  useRef,
  useState,
} from "react";
import { emailLogo, phoneLogo, calenderIcon } from "../../assets/assetsSVG";
import QuestContext from "../QuestWrapper";

import "./css/input.css";

const LogoType = {
  email: emailLogo,
  phone: phoneLogo,
  text: () => <></>,
  number: phoneLogo,
  date: calenderIcon,
};
export type logoType = keyof typeof LogoType;
interface PropType {
  placeholder?: string;
  type: keyof typeof LogoType;
  style?: CSSProperties | undefined;
  onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
  onKeyUp?: KeyboardEventHandler<HTMLInputElement> | undefined;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement> | undefined;
  iconColor?: string;
  value?: string;
  logoPosition?: "left" | "right" | "both";
  ref?: RefObject<HTMLInputElement>;
  emailErrorStyle?: CSSProperties | undefined;
  emailtext?: string | any;
  required?: boolean;
  regexKey?: string | undefined;
  regexMessage?: string;
  name?: string;
  preventFutureSelection?: boolean;
  preventPastSelection?: boolean;
}

export const Input = ({
  placeholder,
  type,
  style,
  onChange,
  iconColor,
  value,
  onKeyUp,
  onKeyDown,
  ref,
  logoPosition = "right",
  emailErrorStyle,
  emailtext,
  required,
  regexKey,
  regexMessage,
  name,
  preventFutureSelection,
  preventPastSelection,
}: PropType) => {
  const { themeConfig } = useContext(QuestContext.Context);

  const dateRef = useRef<HTMLInputElement>(null);
  const [isValidEmail, setIsValidEmail] = useState(true);

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const fallbackPattern = type === "email" ? emailPattern : /^.+$/;

  const isValidRegex = (pattern: string | undefined): boolean => {
    try {
      new RegExp(pattern || "");
      return true;
    } catch {
      return false;
    }
  };

  const emailRegex = !regexKey
    ? fallbackPattern
    : isValidRegex(regexKey)
    ? new RegExp(regexKey)
    : fallbackPattern;

  const validateEmail = (inputValue: string) => {
    if (inputValue) {
      setIsValidEmail(emailRegex.test(inputValue));
    } else {
      setIsValidEmail(true);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    if (type === "email" || !!regexKey) {
      validateEmail(inputValue);
    }
    if (onChange) {
      onChange(e);
    }
  };

  const handleInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    if (type === "email" || !!regexKey) {
      validateEmail(inputValue);
    }
  };

  return (
    <>
      {type === "date" ? (
        <div
          className="q_input_cont"
          onClick={() => dateRef.current?.showPicker()}
          style={{
            borderColor: themeConfig.borderColor,
            color: themeConfig.primaryColor,
            ...style,
          }}
        >
          <label
            htmlFor="dateInput"
            className="q_input_custom_datePicker_label"
          >
            <input
              type={type}
              name="dateInput"
              placeholder={placeholder}
              className="q_input_main_cont q_input_custom_datePicker"
              onChange={onChange}
              value={value}
              required={required}
              ref={dateRef}
              max={
                preventFutureSelection
                  ? new Date(new Date().setDate(new Date().getDate() - 1))
                      .toISOString()
                      .split("T")[0]
                  : undefined
              }
              min={
                preventPastSelection
                  ? new Date().toISOString().split("T")[0]
                  : undefined
              }
            />
            {value ? (
              <div
                style={{
                  display: "inline",
                  marginTop: "2px",
                  color: style?.color,
                  fontSize: style?.fontSize,
                }}
              >
                {value}
              </div>
            ) : (
              <div
                style={{
                  display: "inline",
                  color: "#8E8E8E",
                  marginTop: "2px",
                  fontSize: style?.fontSize,
                }}
              >
                {placeholder}
              </div>
            )}
          </label>
          {LogoType["date"](iconColor || "#B9B9B9")}
        </div>
      ) : (
        <div className="q_input_cont" style={style}>
          {(logoPosition == "left" || logoPosition == "both") &&
            LogoType[type](iconColor || "#B9B9B9")}
          <input
            type={type}
            name={name}
            placeholder={placeholder}
            className="q_input_main_cont"
            onChange={handleInputChange}
            onKeyUp={onKeyUp}
            onKeyDown={onKeyDown}
            // value={value}
            defaultValue={value}
            ref={ref}
            onBlur={handleInputBlur}
            onWheel={(event) => {
              event.currentTarget.blur();
            }}
            style={{
              fontFamily: themeConfig.fontFamily || "'Figtree', sans-serif",
              color: style?.color || themeConfig.primaryColor,
            }}
            required={required}
            pattern={
              type === "email" || !!regexKey ? emailRegex.source : undefined
            }
          />
          {(logoPosition == "right" || logoPosition == "both") &&
            LogoType[type](iconColor || "#B9B9B9")}
        </div>
      )}
      {(type === "email" || !!regexKey) && !isValidEmail && (
        <span style={emailErrorStyle} className="q-input-error-message">
          {regexMessage || emailtext}
        </span>
      )}
    </>
  );
};
